export default __webpack_public_path__ + "static/media/828.fbcc1f58.png";